import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import styled from 'styled-components';
import closeBtn from '../../assets/icons/close.svg';

interface IFormPopup {
  isActive: boolean;
  isWrong: boolean;
  isLoading: boolean;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const FormPopup = ({ isActive, isWrong, setActive, isLoading }: IFormPopup) => {
  const handleClose = () => setActive(false);

  return isLoading ? (
    <Spinner className="loader" animation="border" role="status" />
  ) : (
    <>
      <StyledModal show={isActive} onHide={handleClose}>
        <StyledHeader closeButton>Заявка на франшизу</StyledHeader>
        <StyledBody>
          {!isWrong ? (
            <>
              <span>Заявка отправлена!</span>
              <p>
                Вам на почту отправлен бизнес план. В ближайшее время менеджер с
                Вами свяжется
              </p>
            </>
          ) : (
            <>
              <span>Пожалуйста, заполните все поля в заявке</span>
            </>
          )}
        </StyledBody>
        <Modal.Footer>
          <CancelButton variant="secondary" onClick={handleClose}>
            Закрыть
          </CancelButton>
          <ConfirmButton variant="primary" onClick={handleClose}>
            Вернуться к заявке
          </ConfirmButton>
        </Modal.Footer>
      </StyledModal>
    </>
  );
};

const StyledModal = styled(Modal)`
  & > * {
    font-size: 20px;
  }
`;

const StyledHeader = styled(Modal.Header)`
  font-weight: 600;
  color: #606872;
  padding: 16px;
  & .btn-close {
    width: 14px;
    height: 14px;
    padding: 0;
    margin-right: 5px;
    background: url('${closeBtn}');
    outline: 0;
    border: none;
    -webkit-tap-highlight-color: transparent;
  }
`;

const StyledBody = styled(Modal.Body)`
  padding: 24px 16px;
`;

const ModalButton = styled(Button)`
  border-radius: 8px;
  font-weight: 600;
  padding: 6px 12px;
  border: none;
`;

const ConfirmButton = styled(ModalButton)`
  background: #219653;
  color: #fff;
  &:hover {
    opacity: 0.8;
    background: #219653;
  }
`;

const CancelButton = styled(ModalButton)`
  background: #e7e8eb;
  color: #606872;
  opacity: 0.8;
  background: #e7e8eb;
`;

export default FormPopup;
